// Start-screen clock; format driven by settings. Also drives the dashboard
// date + greeting line.
import { clockEl, dateEl, greetingEl } from "./dom.js";
import { get } from "../shared/settings-store.js";
import { greetingFor } from "./greeting.js";
import { days, isReturn } from "../shared/activity.js";

let timer = null;
let back = null; // "Welcome back", decided once per page load before this visit is recorded
let gKey = "", gText = "";

function str() {
	const d = new Date();
	let h = d.getHours();
	const m = d.getMinutes(), s = d.getSeconds();
	const p = (n) => (n < 10 ? "0" + n : "" + n);
	const sec = get("clockSeconds") ? ":" + p(s) : "";
	if (get("clock24h")) return p(h) + ":" + p(m) + sec;
	const ap = h < 12 ? "AM" : "PM";
	h = h % 12; if (h === 0) h = 12;
	return h + ":" + p(m) + sec + " " + ap;
}

// Recomputed only when the minute or the relevant settings change.
function greeting(d) {
	const name = get("greetingName") || "", touches = get("homeTouches") !== false, bell = get("bellDays");
	const key = Math.floor(d.getTime() / 60000) + "|" + name + "|" + touches + "|" + bell;
	if (key === gKey) return gText;
	if (back === null) { try { back = isReturn(days(), d); } catch { back = false; } }
	gKey = key;
	gText = greetingFor(d, { name, touches, back, bellDays: bell });
	return gText;
}

export function tickClock() {
	const d = new Date();
	if (clockEl) clockEl.textContent = str();
	if (greetingEl) { const g = greeting(d); if (greetingEl.textContent !== g) greetingEl.textContent = g; }
	if (dateEl) { try { dateEl.textContent = d.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" }); } catch (e) { dateEl.textContent = ""; } }
	clearTimeout(timer);
	timer = setTimeout(tickClock, 1000 - (Date.now() % 1000) + 5);
}
